import React from 'react';
import Loader from 'react-loader-spinner'
import {secondaryColor} from "../../assets/scss/colors.scss";

const LoaderSpinner = ({
                           type = "Grid",
                           color = secondaryColor,
                           className = null,
                           height = 35,
                           width = 35,
                           timeOut = 3000,
                       }) => {

    return (
        <div className={className}>
            <Loader
                type={type}
                color={color}
                height={height}
                width={width}
                timeout={timeOut} //3 secs
            />
        </div>
    );
};

export default LoaderSpinner;